var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _circle, _circle2, _circle3, _circle4, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "primaryGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8B5CF6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6D28D9",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dataGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2DD4BF",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0D9488",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGlow",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8B5CF6",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6D28D9",
      stopOpacity: 0.05
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#F8FAFC",
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 12,
    fill: "url(#primaryGradient)",
    filter: "drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,50 L-30,50 M100,50 L130,50",
    stroke: "#8B5CF6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,0 L50,-30 M50,100 L50,130",
    stroke: "#8B5CF6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 60,
    fill: "#FFFFFF",
    fontFamily: "Arial",
    fontSize: 24,
    fontWeight: "bold"
  }, "AI"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 80,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#8B5CF6",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#8B5CF6",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 35,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#8B5CF6",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 40,
    r: 3,
    fill: "#8B5CF6"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    path: "M0,0 L90,10",
    dur: "2s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 80,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 40,
    height: 10,
    rx: 2,
    fill: "url(#dataGradient)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 35,
    width: 30,
    height: 10,
    rx: 2,
    fill: "url(#dataGradient)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 55,
    width: 20,
    height: 10,
    rx: 2,
    fill: "url(#dataGradient)",
    opacity: 0.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140, 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "#FFFFFF",
    stroke: "#8B5CF6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: -5,
    y: 5,
    fill: "#8B5CF6",
    fontFamily: "monospace",
    fontSize: 12
  }, "1"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(260, 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "#FFFFFF",
    stroke: "#8B5CF6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: -5,
    y: 5,
    fill: "#8B5CF6",
    fontFamily: "monospace",
    fontSize: 12
  }, "2"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140, 260)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "#FFFFFF",
    stroke: "#8B5CF6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: -5,
    y: 5,
    fill: "#8B5CF6",
    fontFamily: "monospace",
    fontSize: 12
  }, "3"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(260, 260)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "#FFFFFF",
    stroke: "#8B5CF6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: -5,
    y: 5,
    fill: "#8B5CF6",
    fontFamily: "monospace",
    fontSize: 12
  }, "4"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8B5CF6",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155,40 L245,40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,55 L140,245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,55 L260,245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,260 L245,260"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 40,
    r: 3,
    fill: "#8B5CF6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 150,
    r: 3,
    fill: "#8B5CF6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;1;0.2",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 150,
    r: 3,
    fill: "#8B5CF6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 260,
    r: 3,
    fill: "#8B5CF6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;1;0.2",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 20,
    fill: "url(#bgGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 50,
    r: 20,
    fill: "url(#bgGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 250,
    r: 20,
    fill: "url(#bgGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 250,
    r: 20,
    fill: "url(#bgGlow)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.e4afac2f4d9cc05ef1ace52c6ffa7370.svg";
export { ForwardRef as ReactComponent };